import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { styles } from "./styles";
import { useSearch } from "../../../hooks/seach/useSearch";

export default function Target() {
    const {
        complaintTarget, setComplaintTarget
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Serviço de Destino: *
            </Typography>
            <FormControl variant="outlined" style={styles.formControl} >
                <Select
                    onChange={e => setComplaintTarget(e.target.value)}
                    value={complaintTarget}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="Cidadão">Cidadão</MenuItem>
                    <MenuItem value="Visão">Visão</MenuItem>
                </Select>
            </FormControl>
        </>
    );
}